import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-bold text-foreground-50 font-heading whitespace-nowrap">
              51视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-2 bg-background-800/60 rounded-full px-4 py-2">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索视频..."
                className="bg-transparent text-sm text-foreground-200 placeholder-foreground-500 outline-none w-36 focus:w-48 transition-all"
              />
            </div>

            <button
              className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-300"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-800/50 py-4 flex flex-col gap-1">
            <div className="flex items-center gap-2 bg-background-800/60 rounded-full px-4 py-2 mb-3">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索视频..."
                className="bg-transparent text-sm text-foreground-200 placeholder-foreground-500 outline-none w-full"
              />
            </div>
            <Link
              to="/"
              className={`px-4 py-3 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}